import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../../models/work-item';
import { UIWorkFieldModel, UIPropertyModel } from 'e5core-angular-services';

@Component({
  selector: 'e5core-ui-work-field-material',
  templateUrl: './e5core-ui-work-field-material.component.html',
  styleUrls: ['./e5core-ui-work-field-material.component.css']
})
export class E5coreUiWorkFieldMaterialComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input('field') field: UIWorkFieldModel ;
  @Input('property') property: UIPropertyModel ;
  @Input() readonly: boolean;

  constructor(protected cd: ChangeDetectorRef) { }

  ngOnInit() {
    if (this.workItem$) {
      this.workItem$.subscribe(
      );
    }
  }

}
